import { __awaiter } from "tslib";
import Vue from 'vue';
import translation from '@/assets/rawData/i18n/buddyPage.json';
import applyPageI18NMessages from '@/vue-utils/i18n';
import BuddyAsideWidget from './components/widgets/BuddyAsideWidget.vue';
import BuddyMainWidget from './components/widgets/BuddyMainWidget.vue';
import { ActivePopupTypes } from '@whitelist/wl-old-library/components/global/types';
import BigNumber from 'bignumber.js';
import ReqAfterKyc from './../spotPage/kyc-plugs/RegAfterKyc.vue';
import { mapGetters } from 'vuex';
export var BuddyInnerStatus;
(function (BuddyInnerStatus) {
    BuddyInnerStatus["noData"] = "NO_DATA";
    BuddyInnerStatus["api"] = "API";
    BuddyInnerStatus["started"] = "STARTED";
    BuddyInnerStatus["exit"] = "EXITED";
    BuddyInnerStatus["waitApi"] = "WAIT_API";
    BuddyInnerStatus["base"] = "BASE";
    BuddyInnerStatus["test"] = "TEST";
    BuddyInnerStatus["ready"] = "READY";
    BuddyInnerStatus["downSq"] = "DOWN_SQ";
    BuddyInnerStatus["downStrategy"] = "DOWN_STRATEGY";
})(BuddyInnerStatus || (BuddyInnerStatus = {}));
export var BuddyStatus;
(function (BuddyStatus) {
    BuddyStatus["unplugged"] = "notConnected";
    BuddyStatus["inactive"] = "notActive";
    BuddyStatus["test"] = "inTesting";
    BuddyStatus["active"] = "active";
})(BuddyStatus || (BuddyStatus = {}));
export var BuddyProgress;
(function (BuddyProgress) {
    BuddyProgress["process"] = "inProgress";
    BuddyProgress["success"] = "success";
    BuddyProgress["notStarted"] = "notStarted";
    BuddyProgress["reject"] = "reject";
})(BuddyProgress || (BuddyProgress = {}));
export var StagesNames;
(function (StagesNames) {
    StagesNames["agreement"] = "agreement";
    StagesNames["APIKey"] = "APIKey";
    StagesNames["sq"] = "sq";
    StagesNames["testing"] = "testing";
    StagesNames["buddy"] = "buddy";
})(StagesNames || (StagesNames = {}));
export var InfoBlock;
(function (InfoBlock) {
    InfoBlock["unknown"] = "unknown";
    InfoBlock["init"] = "init";
    InfoBlock["creatingApiKey"] = "creatingApiKey";
    InfoBlock["apiCreatedAnalyzing"] = "apiCreatedAnalyzing";
    InfoBlock["activeGroupRejected07XsS"] = "activeGroupRejected07XsS";
    InfoBlock["activeGroupRejected07ML"] = "activeGroupRejected07ML";
    InfoBlock["activeGroupRejected07085XsSML"] = "activeGroupRejected07085XsSML";
    InfoBlock["sqNoData"] = "sqNoData";
    InfoBlock["tradingTestInProgress"] = "tradingTestInProgress";
    InfoBlock["tradingTestFailedBySq"] = "tradingTestFailedBySq";
    InfoBlock["tradingTestFailedByStrategy"] = "tradingTestFailedByStrategy";
    InfoBlock["ready"] = "ready";
    InfoBlock["downSq"] = "downSq";
})(InfoBlock || (InfoBlock = {}));
const getMock = () => __awaiter(void 0, void 0, void 0, function* () {
    yield new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve('got mock');
        }, 1500);
    });
    return {
        connectionStatus: BuddyStatus.inactive,
        sqValue: 0.23,
        sqBorder: 1,
        info: InfoBlock.init,
        innerStatus: BuddyInnerStatus.api,
        stages: [
            {
                name: StagesNames.agreement,
                progress: BuddyProgress.success
            },
            {
                name: StagesNames.APIKey,
                progress: BuddyProgress.success
            },
            {
                name: StagesNames.sq,
                progress: BuddyProgress.process
            },
            {
                name: StagesNames.testing,
                progress: BuddyProgress.notStarted
            },
            {
                name: StagesNames.buddy,
                progress: BuddyProgress.notStarted
            }
        ]
    };
});
export default Vue.extend({
    name: 'BuddyPage',
    data: () => ({
        loadError: false,
        loading: true,
        agreement: false,
        updateDataTimeout: null,
        info: InfoBlock.init,
        buddyStatus: BuddyStatus.unplugged,
        stages: [],
        sqValue: BigNumber(0),
        sqBorder: BigNumber(0),
        sqLowerThanAcceptable: false,
        innerStatus: BuddyInnerStatus.api,
        isInnerStatusHideApikey: false,
        currentStage: StagesNames.agreement,
        sqStatus: BuddyProgress.notStarted,
        testingStatus: BuddyProgress.notStarted
    }),
    methods: {
        agreementHandler(value) {
            this.agreement = value;
        },
        exitBuddy() {
            const context = this;
            this.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: this.$t('buddyPage.popups.titles.buddyExit'),
                slot: {
                    name: 'exitBuddy',
                    data: {
                        updateBuddyStatusFn: context.getBuddyData
                    }
                }
            });
        },
        unauthorizedHandler() {
            window.location.href = `https://${window.location.host}/binance/not-found`;
        },
        getBuddyData(silent = true) {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (!silent) {
                        this.loadError = false;
                        this.loading = true;
                    }
                    const response = yield this.services.buddy.getBuddyData();
                    if (response.status === 403)
                        this.unauthorizedHandler();
                    if (response.status !== 200)
                        throw new Error();
                    const { stages, sqValue, sqBorder, connectionStatus, info, innerStatus } = response.data.payload;
                    // const { stages, sqValue, sqBorder, connectionStatus, info, innerStatus } = await getMock()
                    const isInnerStatusExit = innerStatus === BuddyInnerStatus.exit || innerStatus === BuddyInnerStatus.waitApi;
                    if (isInnerStatusExit) {
                        this.agreement = false;
                        this.info = InfoBlock.init;
                    }
                    this.isInnerStatusHideApikey = innerStatus === BuddyInnerStatus.base || innerStatus === BuddyInnerStatus.waitApi || innerStatus === BuddyInnerStatus.exit;
                    this.innerStatus = isInnerStatusExit
                        ? BuddyInnerStatus.api
                        : innerStatus;
                    this.buddyStatus = connectionStatus;
                    this.stages = stages;
                    this.info = info !== null && info !== void 0 ? info : InfoBlock.init;
                    this.sqValue = BigNumber(sqValue);
                    this.sqBorder = BigNumber(sqBorder !== null && sqBorder !== void 0 ? sqBorder : 0);
                    this.sqLowerThanAcceptable = this.sqValue.lte(this.sqBorder);
                    this.currentStage = (_b = (_a = stages.find((stage) => stage.progress === BuddyProgress.process || stage.progress === BuddyProgress.reject)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : StagesNames.agreement;
                    this.sqStatus = (_d = (_c = stages.find((stage) => stage.name === StagesNames.sq)) === null || _c === void 0 ? void 0 : _c.progress) !== null && _d !== void 0 ? _d : BuddyProgress.notStarted;
                    this.testingStatus = (_f = (_e = stages.find((stage) => stage.name === StagesNames.testing)) === null || _e === void 0 ? void 0 : _e.progress) !== null && _f !== void 0 ? _f : BuddyProgress.notStarted;
                    if (this.innerStatus !== BuddyInnerStatus.started) {
                        return clearTimeout(this.updateDataTimeout);
                    }
                    this.updateDataTimeout = setTimeout(() => {
                        this.getBuddyData();
                    }, 10000);
                }
                catch (error) {
                    this.loadError = true;
                    const isObject = typeof error === 'object' && error !== null;
                    if (!isObject)
                        return;
                    const hasResponse = 'response' in error && typeof error.response === 'object';
                    if (!hasResponse)
                        return;
                    const data = error.response;
                    const hasStatus = 'status' in data && typeof data.status === 'number';
                    if (!hasStatus)
                        return;
                    if (data.status === 403)
                        this.unauthorizedHandler();
                }
                finally {
                    this.loading = false;
                }
            });
        }
    },
    beforeDestroy() {
        clearTimeout(this.updateDataTimeout);
    },
    created() {
        applyPageI18NMessages(this, 'buddyPage', translation);
        this.getBuddyData(false);
    },
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData', 'extendedKycStatus'])), { showExitBtn() {
            var _a, _b;
            return (_b = ((_a = this.stages.find((stage) => stage.name === StagesNames.APIKey)) === null || _a === void 0 ? void 0 : _a.progress) === BuddyProgress.success) !== null && _b !== void 0 ? _b : false;
        }, showPlug() {
            return !this.loading && this.extendedKycStatus !== 'accepted' && this.extendedKycStatus !== null;
        } }),
    components: { BuddyAsideWidget, BuddyMainWidget, ReqAfterKyc }
});
